import { AssessmentMaster } from '../../../../src/utils';
export const isEmpty = (...fields: any[]) => {
    let fieldValid = true;
    for (let field of fields) {
        if (isEmpty(field)) {
            fieldValid = false;
            break;
        }
    }
    return fieldValid;
}

export const validateEmail = (email: string) => {
    let isValid = false;
    isValid = String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
        ? true
        : false
    return isValid;
};

export const validatePhoneNumber = (mobile: any) => {
    var re = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
    return re.test(mobile);
}

export var getLoggedInUser = () => JSON.parse(localStorage.getItem("userData") || '{}');

export var getLoggedInUserGUID = () => getLoggedInUser()?.UserGuid;
export var getLoggedInUserEmail = () => getLoggedInUser()?.Email;
export var getTimeZoneID = () => getLoggedInUser()?.TimeZoneID;
export var getTimeZoneText = () => getLoggedInUser()?.TimeZoneText;
export var getTodayDate = () => getLoggedInUser()?.CurrentDate;

export const StringIsNULLOrEmpty = (str: string) => {
    var isValid = true;
    if (str == undefined || str == null || str == "" || str.toString().toLowerCase().indexOf("invalid") > -1) {
        isValid = false;
    }
    return isValid;
}
const ADMIN_PANEL = ['admin', 'adminpatienthealthformNew', 'adminpatientphistory'];
const PATIENT_PANEL = ['patient'];
const COMAPNY_PANEL = ['companyadmin', 'adminpatienthealthform', 'patientnurse'];
// const COMAPNY_PANEL = ['companyadmin'];

export const checkIsAdminPanel = (pathname) => {
    const newPathname = pathname.split("/")?.[1];
    return ADMIN_PANEL.includes(newPathname);
};

export const checkIsPatientPanel = (pathname) => {
    const newPathname = pathname.split("/")?.[1];
    return PATIENT_PANEL.includes(newPathname);
};

export const checkIsCompanyPanel = (pathname) => {
    const newPathname = pathname.split("/")?.[1];
    return COMAPNY_PANEL.includes(newPathname);
};

export const normalizePhoneNumber = (inputNum) => {
    var x = inputNum?.replace(/\D+/g, '')
        .replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
    return x;
}

export const getAssociatedValue = (filterOptions, mappedValue) => {
    const output = filterOptions?.find(element => element.value === mappedValue)?.label;
    return output;
 }

 export const GetAssessmentName = (AssessmentType) => {
    var AssessmentName = '';
    if (AssessmentType == AssessmentMaster.Thoracic) {
        AssessmentName = 'Thoracic Assessment';
    }
    else if (AssessmentType == AssessmentMaster.Cervical) {
        AssessmentName = 'Cervical Assessment';
    }
    else if (AssessmentType == AssessmentMaster.Lumbar) {
        AssessmentName = 'Lumbar Assessment';
    }
    else if (AssessmentType == AssessmentMaster.Lower_Extremities) {
        AssessmentName = 'Lower Extremities Assessment';
    }
    else if (AssessmentType == AssessmentMaster.Upper_Extremities) {
        AssessmentName = 'Upper Extremities Assessment';
    }
    else if (AssessmentType == AssessmentMaster.Re_Assessment) {
        AssessmentName = 'Re-Assessment';
    }
    else if (AssessmentType == AssessmentMaster.Vestibular) {
        AssessmentName = 'Vestibular Assessment';
    }
    else if (AssessmentType == AssessmentMaster.Other_Eval) {
        AssessmentName = 'Other Assessment';
    }
    else if (AssessmentType == AssessmentMaster.Other_FollowUp) {
        AssessmentName = "Other Follow Up Assessment";
    }
    else if (AssessmentType == AssessmentMaster.Other_Eval_OT) {
        AssessmentName = 'Other Assessment - OT';
    }
    else if (AssessmentType == AssessmentMaster.Other_FollowUp_OT) {
        AssessmentName = "Other Follow Up Assessment - OT";
    }
    else if (AssessmentType == 12) {
        AssessmentName = 'Assessment';
    }
    return AssessmentName;
}

 export const maxFileLengthInBytes = 4194304;